import { render, staticRenderFns } from "./TopCollectors.vue?vue&type=template&id=01a12226&scoped=true&"
import script from "./TopCollectors.vue?vue&type=script&lang=js&"
export * from "./TopCollectors.vue?vue&type=script&lang=js&"
import style0 from "./TopCollectors.vue?vue&type=style&index=0&id=01a12226&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01a12226",
  null
  
)

export default component.exports